import React from 'react'

import Section from '../Section'
import Container from '../Container'

type UspsProps = {
  imageSrc: string
  usps: string[]
}

const Usps = ({ imageSrc, usps }: UspsProps) => {
  return (
    <Section className="usp">
      <Container>
        <div className="usp-image">
          <div className="img-container">
            <img src={imageSrc} />
          </div>
        </div>
        <div className="usp-list">
          <ul>
            {usps.map((usp: string, index: number) => {
              return (
                <li key={`usp-${index}`}>
                  <span className="fa fa-check"></span>
                  <span>{usp}</span>
                </li>
              )
            })}
          </ul>
        </div>
      </Container>
    </Section>
  )
}

export default React.memo(Usps)
